import { InputRightElement, useDisclosure } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { HidePasswordIcon, ShowPasswordIcon } from 'src/assets/icons/form-elements/PasswordIcon';
import InputLabelInside from './InputLabelInside';
import { InputRef, TextInputProps } from './TextInput';

export interface PasswordInputProps extends TextInputProps {}

const PasswordInput = forwardRef<InputRef, PasswordInputProps>((props, ref) => {
  const { isOpen: isPasswordVisible, onToggle } = useDisclosure();
  return (
    <InputLabelInside ref={ref} type={isPasswordVisible ? 'text' : 'password'} {...props}>
      <InputRightElement height="100%" onClick={onToggle}>
        {isPasswordVisible ? <HidePasswordIcon /> : <ShowPasswordIcon />}
      </InputRightElement>
    </InputLabelInside>
  );
});

export default PasswordInput;
